//dev avec PHP
//export const API_URL = "http://loyersws/api/";
//prod OVH
export const API_URL = "https://gestion.locabel.ovh/api/";

export const RENT_STATUS_PAID = "PAID";
export const RENT_STATUS_UNPAID = "UNPAID";
export const PAYPAL_CLIENT_ID = "AWPg2Ew-jk7yDA2dsQ8JQiaEUZTNXLgjUzS8d1xZ9svSPC2_hK3s9zF-ztyOVb-9OCiHKh3vxGKztGqi";